module.exports = __webpack_public_path__ + "img/Trophy.ad0396b3.jpg";